import * as yup from "yup";
export const RL3SummarySetupSchema = yup.object().shape({
  rl3FiledOnPaper: yup.string().required("Filed On Paper is required!"),
  rl3FiledOnline: yup.string().required("Filed Online is required!"),
});
